import {RampIdType} from '../../../generated/graphql';
import {type RampKey} from '../../useRampFlag';
import {
  type FeatureFlagMap,
  type FeatureFlagOverrides,
} from './featureFlagOverrideTypes';

export {type FeatureFlagMap, type FeatureFlagOverrides};

function getOverridesForRampIdType(
  rampIDType: RampIdType
): FeatureFlagMap | undefined {
  const all = window.CONFIG?.FEATURE_FLAG_OVERRIDES;
  if (!all) {
    return undefined;
  }

  switch (rampIDType) {
    case RampIdType.EntityId:
    case RampIdType.EntityName:
      return {
        ...all[RampIdType.EntityId],
        ...all[RampIdType.EntityName],
      };
    case RampIdType.OrgId:
    case RampIdType.OrgName:
      return {
        ...all[RampIdType.OrgId],
        ...all[RampIdType.OrgName],
      };
    case RampIdType.UserId:
    case RampIdType.UserName:
      return {
        ...all[RampIdType.UserId],
        ...all[RampIdType.UserName],
      };
    default:
      return all[rampIDType];
  }
}

export function getFeatureFlagOverride(
  rampIDType: RampIdType,
  rampKey: RampKey | string
): boolean | undefined {
  return getOverridesForRampIdType(rampIDType)?.[rampKey];
}

/**
 * Applies feature flag overrides for testing, reads from `window.CONFIG.FEATURE_FLAG_OVERRIDES`.
 * Run this function after loading the flag value to be override, to ensure overrides don't change loading
 * behavior. This is important for accurate page load timing measurements.
 */
export function applyFeatureFlagOverride<T extends boolean | undefined>(
  rampIDType: RampIdType,
  rampKey: RampKey | string,
  value: T
): T {
  const override = getFeatureFlagOverride(rampIDType, rampKey);
  if (override !== undefined) {
    return override as T;
  }
  return value;
}
